<template>
	<div ref="container" style="width: 100%; height: 100%;"></div>
</template>

<script>
import GiftGoalWidget from '@/widgets/GiftGoalWidget';

const mockSocket = { subscribe() { return 0; }, unsubscribe() {} };

export default {
	name: 'GiftGoalWidgetPreview',
	props: {
		settings: { type: Object, default: () => ({}) },
	},
	watch: {
		settings: {
			deep: true,
			handler(s) { this._applySettings(s); },
		},
	},
	mounted() {
		this._initWidget();
	},
	beforeDestroy() {
		this._destroyWidget();
	},
	methods: {
		async _initWidget() {
			const self = this;
			const api = {
				get(path) {
					if(path.includes('/settings/')) return Promise.resolve({ ...self.settings });
					if(path.includes('/userData')) return Promise.resolve({ currency_code: 'USD' });
					return Promise.resolve({});
				},
				post() { return Promise.resolve(); },
			};

			this.widget = new GiftGoalWidget({
				container: this.$refs.container,
				api,
				socket: mockSocket,
				hash: 'preview',
			});
			await this.widget.init();
		},
		_destroyWidget() {
			if(this.widget) {
				this.widget.destroy();
				this.widget = null;
				if(this.$refs.container) this.$refs.container.innerHTML = '';
			}
		},
		_applySettings(s) {
			if(!this.widget) return;
			this.widget.applySettings({ ...s });
		},
	},
};
</script>
